export default __webpack_public_path__ + "static/media/lamp6.0362d722.webp";